// SPDX-License-Identifier: GPL-3.0-or-later
// Copyright (C) 2026 Breach Contributors

import { Routes, Route, Navigate } from 'react-router-dom';
import PrivacySettings from '@/components/settings/PrivacySettings';

export default function Settings() {
  return (
    <div className="mx-auto max-w-3xl p-8">
      <h1 className="mb-6 text-3xl font-bold">Settings</h1>
      <Routes>
        <Route path="/" element={<Navigate to="privacy" replace />} />
        <Route path="privacy" element={<PrivacySettings />} />
      </Routes>
    </div>
  );
}
